import teamsClient from '../../api/central/teams'

// state
const state = {
    teams: [],
    defaultTeam: {}
};

// getters
const getters = {

};

// actions
const actions = {
    async getTeams({ commit }) {
        await teamsClient.index()
            .then(({ data }) => commit("setTeams", data.data))
            .catch((error) => { throw error.response.data.message })
    }
};

// mutations
const mutations = {
    setTeams(state, account) {
        state.teams = account.teams;
        state.defaultTeam = account.defaultTeam;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
